
      export default {
        functional: true,
        render: 
      function render(_h, _vm) {
        var _c=_vm._c;return _c('svg',{class:[_vm.data.class, _vm.data.staticClass],style:([_vm.data.style, _vm.data.staticStyle]),attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24"}},[_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('path',{attrs:{"d":"M0 0h24v24H0z"}}),_c('path',{attrs:{"fill":"#FFF","d":"M7.1 12l9.546 9.546a.5.5 0 1 1-.707.707l-9.9-9.9a.498.498 0 0 1 0-.707l9.9-9.899a.5.5 0 1 1 .707.707L7.101 12z"}})])])
      }
    
      }
    